'use es6';

import Immutable from 'immutable';
import enviro from 'enviro';
import I18n from 'I18n';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import { UnreviewableReasons } from '../constants/Reviewability';
const defaults = {
  isPublic: false,
  installedAt: 0,
  uninstalledAt: 0,
  portalReviewsCount: 0,
  portalEmployeeSize: null,
  portalIndustry: null,
  userAlreadyReviewed: null,
  userOnProviderPortal: null,
  testPortal: null,
  maxPortalReviews: 0,
  maxMillisAfterUninstall: 0
};
export default class AppReviewability extends Immutable.Record(defaults) {
  constructor(data) {
    super(cleanObject(data));
  }

  getUnreviewableReason() {
    const {
      isPublic,
      installedAt,
      uninstalledAt,
      portalReviewsCount,
      userAlreadyReviewed,
      userOnProviderPortal,
      testPortal,
      maxPortalReviews,
      maxMillisAfterUninstall
    } = this;
    const withinUninstallWindow = !uninstalledAt || I18n.moment().diff(I18n.moment(uninstalledAt)) < maxMillisAfterUninstall;
    const withinReviewLimit = portalReviewsCount < maxPortalReviews;
    const isQa = enviro.isQa();

    if (isPublic) {
      return UnreviewableReasons.PUBLIC_USER;
    } else if (!installedAt && !isQa) {
      return UnreviewableReasons.NOT_INSTALLED;
    } else if (!withinUninstallWindow && !isQa) {
      return UnreviewableReasons.UNINSTALLED;
    } else if (!withinReviewLimit && !isQa) {
      return UnreviewableReasons.LIMIT_REACHED;
    } else if (userAlreadyReviewed) {
      return UnreviewableReasons.ALREADY_REVIEWED;
    } else if (userOnProviderPortal && !isQa) {
      return UnreviewableReasons.PROVIDER_USER;
    } else if (testPortal) {
      return UnreviewableReasons.TEST_PORTAL_USER;
    } else {
      return false;
    }
  }

  isReviewable() {
    return !this.getUnreviewableReason();
  }

}